import React from "react";
import Header from "../../components/Header";
import { constants } from "../../Constants";
import { appointmentActions } from "../../store/actions";
import { connect } from "react-redux";
import SessionPatientDetails from "../../components/SessionAndPatientDetail/SessionPatientDetail";
import Loading from "../../components/Loading/Loading";
import Footer from "../../components/Footer/footer";
import moment from "moment";
import Swal from "sweetalert2";
import { sessionService } from "../../services";

class PatientDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            patient_detail: null,
            totalSessionCaps: '',
            consumedSessionCaps: ''
        }
    }

    async resetSessionHandler(id) {
        Swal.fire({
            title: constants.RESET_SESSION_CAP_TXT,
            text: constants.HAVE_YOU_TAKEN_PERMISSION_TXT,
            showCancelButton: true,
            cancelButtonText: constants.NO_TXT,
            confirmButtonText: constants.CONFIRM_BUTTON_TEXT,
            confirmButtonColor: constants.CONFIRM_BUTTON_COLOUR,
        }).then(async (result) => {
            if (result.value) {
                try {
                    const res = await sessionService.resetSessionCap({
                        patient_id: id
                    });
                    if (res) {
                        Swal.fire({
                            icon: "success",
                            text: constants.SESSION_CAPS_RESET_TXT
                        });
                        this.props.getPatientDetail(id);
                    }
                } catch (error) {
                    Swal.fire({
                        icon: "error",
                        text: constants.SESSION_RESET_FAILED_TXT || "An error occurred. Please try again."
                    });
                }
            }
        });

    }

    getInitials(name) {
        const parts = name.split(" ")
        const initials = parts[0].charAt(0).toUpperCase() + (parts.length > 1 ? parts[1].charAt(0).toUpperCase() : '');

        return initials
    }
    componentWillMount() {
        let currentID = window.location.href.split("patient-details/")[1]
        this.props.getPatientDetail(currentID)
    }

    componentWillReceiveProps(nextProps) {

        this.setState({ patient_detail: nextProps.patient_detail, consumedSessionCaps: nextProps.patient_detail.consumed_session_cap, totalSessionCaps: nextProps.patient_detail.total_session_cap })
    }

    render() {
        let totalSessionCaps;
        let consumedSessionCaps
        let patientName
        let isSessionCapAllowed
        const user = JSON.parse(localStorage.getItem("user"))

        if (this.state.patient_detail) {
            patientName = this.state.patient_detail.user.full_name
            totalSessionCaps = this.state.totalSessionCaps
            consumedSessionCaps = this.state.consumedSessionCaps
            isSessionCapAllowed = this.state.patient_detail.project.is_session_cap_allowed

        }
        return (
            <div className="sh-layout">
                <Header />
                {this.state.patient_detail ?
                    <SessionPatientDetails
                        detailHeading={constants.PATIENT_DETAILS_TXT}
                        initials={patientName && this.getInitials(patientName)}
                        userName={patientName}
                        sessionDate={this.props.patient_detail && moment(this.props.patient_detail.date_created).format("dddd DD MMMM")}
                        sessionTime={this.props.patient_detail && moment(this.props.patient_detail.date_created).format('hh:mm a')}
                        serviceType={user.counsellor.service_type.name}
                        showServiceType={true}
                        totalSessionCaps={totalSessionCaps}
                        consumedSessionCaps={consumedSessionCaps}
                        isSessionCapAllowed={isSessionCapAllowed}
                        canReset={isSessionCapAllowed}
                        resetHandler={() => this.props.patient_detail && this.resetSessionHandler(this.state.patient_detail.id)}

                    />
                    : <Loading />}
                <Footer />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { appointments, patient_detail } = state.appointments;
    const { user } = state.auth

    return {
        appointments,
        user,
        patient_detail
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAppointments: (id) => {
            dispatch(appointmentActions.getAppointments(id));
        },
        getPatientDetail: (id) => {
            dispatch(appointmentActions.getPatientDetail(id))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientDetails)



// WEBPACK FOOTER //
// ./src/screens/PatientDetails/index.js